<!--
 * @Descripttion: ZENRADING SHOP 项目根组件 - Terracotta & Gold Ethnic Theme
 * @Author: ZENRADING SHOP
 * @Date: 2026-05-11
--> 

<template>
  <div id="app" name="app">
    <el-container>
      <!-- 顶栏容器 -->

      <el-header v-show="$route.meta.showMenu!==false" style="background-color:var(--color-bg);border-bottom:0;box-shadow:none;">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          active-text-color="#C75D3D"
          background-color="transparent"
          text-color="#2D2D2D"
          router
          style="border-bottom:0;box-shadow:none;"
        >
          <div class="logo">
            <router-link to="/">
              <img src="./assets/imgs/logo.svg" alt />
            </router-link>
          </div>
          <el-menu-item index="/">HOME</el-menu-item>
          <el-menu-item index="/goods">WOMEN</el-menu-item>
          <el-menu-item index="/about?id=1">About Me</el-menu-item>
          <el-submenu index="faqs">
            <template slot="title">FAQs</template>
            <el-menu-item index="/faqs?section=shopping">Shopping Information</el-menu-item>
            <el-menu-item index="/about?id=4">Return &amp; Cancellation</el-menu-item>
          </el-submenu>
          <el-menu-item index="/contact">Contact Us</el-menu-item>
          <div class="site-search">
            <el-input
              v-model="search"
              placeholder="Search product..."
              class="site-search-input dark-theme"
              @keyup.enter.native="searchClick"
            >
              <el-button slot="append" icon="el-icon-search" @click="searchClick"></el-button>
            </el-input>
          </div>
          <div class="menu-right">
            <div v-if="!this.$store.getters.getUser" class="menu-auth-wrap">
              <div class="menu-auth-trigger">
                <router-link to="/login" style="color: #fff;">Login</router-link>
                <span style="color: #fff;">/</span>
                <router-link to="/register" style="color: #fff;">Register</router-link>
              </div>
              <div class="menu-auth-panel">
                <div class="auth-tabs">
                  <span class="active">Sign in</span>
                  <router-link to="/register">Create an Account</router-link>
                </div>
                <div class="auth-field">Username or email address</div>
                <el-input size="mini" placeholder="Username or email address"></el-input>
                <div class="auth-field">Password</div>
                <el-input size="mini" type="password" placeholder="Password"></el-input>
                <el-button size="mini" type="primary" class="auth-submit">Log In</el-button>
                <div class="auth-footer">
                  <label><input type="checkbox" /> Remember me</label>
                  <router-link to="/login">Lost your password?</router-link>
                </div>
              </div>
            </div>
            <div v-else class="header-user-con">
              <div class="user-avator">
                <img :src="this.$store.getters.getUser.avatar" @error="handleAvatarError" />
              </div>
              <div class="user-name">
                <el-dropdown>
                  <span class="el-dropdown-link">
                    {{this.$store.getters.getUser.nickname}}
                    <i class="el-icon-caret-bottom"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <router-link to="/center">
                      <el-dropdown-item>Personal Center</el-dropdown-item>
                    </router-link>
                    <a @click="logout">
                      <el-dropdown-item>Logout</el-dropdown-item>
                    </a>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <router-link class="menu-text" to="/favorite">Wishlist</router-link>
            <router-link :class="getNum > 0 ? 'menu-cart menu-cart-full' : 'menu-cart'" to="/cart">
              Cart
              <span>{{getNum}}</span>
            </router-link>
          </div>
        </el-menu>
      </el-header>

      <!-- 顶栏容器END -->

      <!-- 移动端顶部栏 -->
      <div class="mobile-header" v-show="$route.meta.showMenu!==false">
        <div class="mobile-header-inner">
          <a href="javascript:void(0)" class="mobile-menu" @click.prevent="mobileMenuVisible = true">
            <i class="el-icon-menu"></i>
            <span>Menu</span>
          </a>
          <router-link class="mobile-logo" to="/">
            <img src="./assets/imgs/logo.svg" alt />
          </router-link>
          <router-link class="mobile-cart" to="/cart">
            <i class="el-icon-shopping-cart-full"></i>
            <span v-if="getNum>0" class="badge">{{getNum}}</span>
          </router-link>
        </div>
      </div>
      <!-- 移动端顶部栏END -->

      <!-- 移动端抽屉菜单 -->
      <el-drawer
        :visible.sync="mobileMenuVisible"
        direction="ltr"
        size="80%"
        custom-class="mobile-drawer"
        :with-header="false"
      >
        <div class="mobile-drawer-header">
          <span>Menu</span>
          <i class="el-icon-close" @click="mobileMenuVisible=false"></i>
        </div>
        <div class="mobile-drawer-body">
          <el-input
            v-model="mobileSearch"
            placeholder="Search for products"
            class="mobile-search"
            @keyup.enter.native="mobileSearchClick"
          >
            <el-button slot="append" icon="el-icon-search" @click="mobileSearchClick"></el-button>
          </el-input>
          <div class="drawer-switch">
            <button
              class="switch-btn"
              :class="{active: mobileMenuTab==='collection'}"
              @click="mobileMenuTab='collection'"
            >
              Collection
            </button>
            <button
              class="switch-btn"
              :class="{active: mobileMenuTab==='menu'}"
              @click="mobileMenuTab='menu'"
            >
              Menu
            </button>
          </div>
          <div class="drawer-content">
            <div v-if="mobileMenuTab==='collection'" class="mobile-drawer-section">
              <div class="section-title">Collection</div>
              <ul class="link-list">
                <li v-for="item in shopCategories" :key="item.category_id">
                  <router-link :to="`/goods?categoryID=${item.category_id}`" @click.native="mobileMenuVisible=false">
                    {{item.category_name}}
                  </router-link>
                </li>
              </ul>
            </div>
            <div v-else class="mobile-drawer-section">
              <div class="section-title">Menu</div>
              <ul class="link-list">
                <li><router-link to="/" @click.native="mobileMenuVisible=false">Home</router-link></li>
                <li><router-link to="/about?id=1" @click.native="mobileMenuVisible=false">About Me</router-link></li>
                <li><router-link to="/order" @click.native="mobileMenuVisible=false">My Order</router-link></li>
                <li><router-link to="/favorite" @click.native="mobileMenuVisible=false">Wishlist</router-link></li>
                <li><router-link to="/goods" @click.native="mobileMenuVisible=false">All Products</router-link></li>
              </ul>
            </div>
          </div>
        </div>
      </el-drawer>
      <!-- 移动端抽屉菜单END -->

      <!-- 主要区域容器 -->
      <el-main>
        <keep-alive>
          <router-view :key="key"></router-view>
        </keep-alive>
      </el-main>
      <!-- 主要区域容器END -->

      <!-- 移动端底部TabBar -->
      <div class="mobile-tabbar" v-show="$route.meta.showMenu!==false">
        <router-link to="/goods" class="tab">
          <i class="el-icon-s-goods"></i>
          <span>Shop</span>
        </router-link>
        <router-link to="/favorite" class="tab">
          <i class="el-icon-star-off"></i>
          <span>Wishlist</span>
        </router-link>
        <router-link to="/cart" class="tab">
          <i class="el-icon-shopping-cart-1"></i>
          <span>Cart</span>
          <em v-if="getNum>0" class="dot">{{getNum}}</em>
        </router-link>
        <router-link to="/center" class="tab">
          <i class="el-icon-user"></i>
          <span>My account</span>
        </router-link>
      </div>
      <!-- 移动端底部TabBar END -->

      <!-- 底栏容器 -->
      <el-footer>
        <div class="footer">
          <div class="footer-subscribe-section">
             <div class="subscribe-title">Join Our Style Family</div>
             <div class="subscribe-action">
                <button class="subscribe-btn-arrow"><i class="el-icon-right"></i></button>
             </div>
          </div>
          <div class="footer-content">
            <div class="footer-links-group">
              <div class="footer-col">
                <h4>Shop & Information</h4>
                <router-link to="/about?id=1">About Us</router-link>
                <router-link to="/contact">Contact Us</router-link>
                <router-link to="/about?id=6">Terms of Service</router-link>
                <router-link to="/about?id=2">Privacy Policy</router-link>
              </div>
              <div class="footer-col">
                <h4>Help</h4>
                <router-link to="/about?id=3">Shipping & Delivery</router-link>
                <router-link to="/about?id=4">Returns & Exchanges</router-link>
                <router-link to="/faqs">FAQs</router-link>
              </div>
               <div class="footer-col">
                <h4>About Us</h4>
                <router-link to="/about?id=1">Our Story</router-link>
                <router-link to="/contact">Careers</router-link>
                <router-link to="/contact">Press</router-link>
              </div>
            </div>

             <div class="footer-right-promo">
               <h4>Trending This Season</h4>
               <p>Discover elegance in every thread</p>
               <div class="footer-promo-links">
                  <router-link to="/goods">Silk Sarees <i class="el-icon-right"></i></router-link>
                  <router-link to="/goods">Anarkali Suits <i class="el-icon-right"></i></router-link>
                  <router-link to="/goods">Designer Lehengas <i class="el-icon-right"></i></router-link>
               </div>
            </div>
          </div>
          <div class="footer-copyright">
            Copyright © 2026, ZENRADING EXIM PRIVATE LIMITED. All Rights Reserved.
          </div>
        </div>
      </el-footer>
      <!-- 底栏容器END -->
    </el-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'
import * as cartsAPI from '@/api/carts'
import * as userAPI from '@/api/users'
import * as categoryAPI from '@/api/categories'

export default {
  beforeUpdate() {
    this.activeIndex = this.$route.path
  },
  data() {
    return {
      activeIndex: '', // 头部导航栏选中的标签
      search: '', // 搜索条件
      shopCategories: [],
      mobileMenuVisible: false,
      mobileSearch: '',
      mobileMenuTab: 'collection'
    }
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'background:#FDF8F5')
  },
  created() {
    // 获取浏览器localStorage，判断用户是否已经登录
    userAPI.checkToken(localStorage.getItem('token')).then(res => {
      // 如果已经登录，设置vuex登录状态
      if (res.status == 200) {
        this.setUser(JSON.parse(localStorage.getItem('user')))
      } else {
        localStorage.removeItem('user')
        localStorage.removeItem('token')
      }
    })
    categoryAPI
      .listCategories()
      .then(res => {
        if (res.status === 200) {
          this.shopCategories = res.data
        } else {
          this.notifyError('Failed to obtain classification', res.msg)
        }
      })
      .catch(err => {
        this.notifyError('Failed to obtain classification', err)
      })
  },
  computed: {
    ...mapGetters(['getUser', 'getNum']),
    key() {
      return this.$route.path
    }
  },
  watch: {
    // 获取vuex的登录状态
    getUser: function(val) {
      if (val === '') {
        // 用户没有登录
        this.setShoppingCart([])
      } else {
        // 用户已经登录,获取该用户的购物车信息
        cartsAPI
          .showCarts(val.id)
          .then(res => {
            if (res.status === 200) {
              if (res.data === null) {
                this.setShoppingCart([])
              } else {
                this.setShoppingCart(res.data)
              }
            } else if (res.status === 20001) {
              //token过期，需要重新登录
              this.loginExpired(res.msg)
            } else {
              this.$notify.error({
                title: '购物车获取失败',
                message: res.msg
              })
            }
          })
          .catch(err => {
            return Promise.reject(err)
          })
      }
    }
  },
  methods: {
    ...mapActions(['setUser', 'setShoppingCart']),
    login() {
      this.$router.push({
        name: 'Login'
      })
    },
    // 退出登录
    logout() {
      // 清空本地登录信息
      localStorage.removeItem('user')
      localStorage.removeItem('token')
      // 清空vuex登录信息
      this.setUser('')
      this.$router.push({
        name: 'Home'
      })
      this.notifySucceed('登出成功')
    },
    // 默认头像处理
    handleAvatarError(e) {
      e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="%234A6FA5" stroke="%234A6FA5" stroke-width="1"%3E%3Ccircle cx="12" cy="8" r="4"/%3E%3Cpath d="M4 20c0-4 4-6 8-6s8 2 8 6"/%3E%3C/svg%3E'
    },
    //重定向
    register() {
      this.$router.push({
        name: 'Register'
      })
    },
    // 点击搜索按钮
    searchClick() {
      if (this.search != '') {
        // 跳转到全部商品页面,并传递搜索条件
        this.$router.push({ path: '/goods', query: { search: this.search } })
        this.search = ''
      }
    },
    mobileSearchClick() {
      if (this.mobileSearch) {
        this.$router.push({ path: '/goods', query: { search: this.mobileSearch } })
        this.mobileSearch = ''
        this.mobileMenuVisible = false
      }
    }
  }
}
</script>

<style>
/* 全局CSS */
* {
  padding: 0;
  margin: 0;
  border: 0;
  list-style: none;
}

.header-user-con {
  display: flex;
  height: 44px;
  align-items: center;
}
.user-name {
  margin-left: 10px;
}
.user-avator img {
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.el-dropdown-link {
  color: #fff;
  cursor: pointer;
}

.el-dropdown-menu__item {
  text-align: center;
}
.el-dropdown-item:hover {
  color: #C75D3D;
}

#app .el-header {
  padding: 0;
}
#app .el-main {
  min-height: 300px;
  padding: 0;
  overflow: visible;
}
#app .el-footer {
  padding: 0;
}
a,
a:hover {
  text-decoration: none;
}
/* 全局CSS END */

/* 默认隐藏移动端专用按钮（桌面端不显示） */
.mobile-header,
.mobile-tabbar {
  display: none;
}

/* 顶部导航栏CSS */
/* 顶栏容器CSS */
.el-header {
  margin-bottom: 0;
  background-color: #FDF8F5;
  border-bottom: 0;
}
.el-header .el-menu {
  max-width: 1280px;
  width: 100%;
  margin: 0 auto;
  padding: 0 24px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: transparent;
  flex-wrap: nowrap;
  border-bottom: 0;
}
.el-menu--horizontal>.el-menu-item.is-active {
  color: #C75D3D;
}
.el-menu--horizontal {
  border-bottom: 0;
}
.el-menu--horizontal > .el-menu-item,
.el-menu--horizontal > .el-submenu .el-submenu__title {
  border-bottom: 0;
  position: relative;
  transition: all 0.3s ease;
}
.el-menu--horizontal > .el-menu-item::after,
.el-menu--horizontal > .el-submenu .el-submenu__title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #C75D3D, #D4A574);
  transition: all 0.3s ease;
  transform: translateX(-50%);
}
.el-menu--horizontal > .el-menu-item:hover::after,
.el-menu--horizontal > .el-submenu:hover .el-submenu__title::after {
  width: 100%;
}

.el-header .logo {
  height: 60px;
  width: 100px;
  float: left;
  margin-right: 40px;
  flex-shrink: 0;
  transition: transform var(--transition-spring);
}
.el-header .logo:hover {
  transform: scale(1.05);
}
.site-search {
  margin-left: 16px;
  margin-right: auto;
  width: 520px;
  max-width: 42vw;
}
.site-search-input .el-input__inner {
  background-color: #FFFFFF;
  border: 1.5px solid rgba(185, 54, 91, 0.15);
  color: #2D2D2D;
  border-radius: 24px 0 0 24px;
}
.site-search-input .el-input-group__append {
  background-color: #C75D3D;
  border: 1.5px solid #C75D3D;
  border-left: 0;
  border-radius: 0 24px 24px 0;
  padding: 0;
}
.site-search-input .el-input-group__append .el-button {
  background: transparent;
  border: none;
  color: #FFFFFF;
  margin: 0;
  padding: 12px 20px;
}
.site-search-input .el-input-group__append .el-button:hover {
  color: #FFFFFF;
  background-color: #A1482A;
}
.el-menu--horizontal > .el-menu-item,
.el-menu--horizontal > .el-submenu {
  flex-shrink: 0;
}
.el-header .logo img {
  height: 52px;
  margin-top: 4px;
  border-radius: 8px;
}
.menu-right {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 16px;
  color: #2D2D2D;
  flex-shrink: 0;
}
.menu-auth-wrap {
  position: relative;
}
.menu-auth-trigger {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #2D2D2D;
  white-space: nowrap;
}
.menu-auth-trigger a {
  color: #C75D3D;
}
.menu-auth-panel {
  position: absolute;
  right: 0;
  top: 34px;
  width: 270px;
  background: #ffffff;
  color: #2f2238;
  border-radius: 6px;
  padding: 14px;
  box-shadow: 0 16px 30px rgba(0, 0, 0, 0.18);
  display: none;
  z-index: 10;
}
.menu-auth-wrap:hover .menu-auth-panel {
  display: block;
}
.auth-tabs {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin-bottom: 10px;
}
.auth-tabs .active {
  font-weight: 600;
  color: #2f2238;
}
.auth-tabs a {
  color: #6d637b;
}
.auth-field {
  font-size: 11px;
  color: #6d637b;
  margin: 8px 0 4px;
}
.auth-submit {
  margin-top: 10px;
  width: 100%;
  background: #C75D3D;
  border-color: #C75D3D;
}
.auth-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 11px;
  color: #6d637b;
  margin-top: 10px;
}
.auth-footer a {
  color: #6d637b;
}
.auth-footer input {
  margin-right: 6px;
}
.menu-text {
  color: #FFFFFF;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.menu-cart {
  position: relative;
  padding-right: 10px;
}
.menu-cart span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  font-size: 11px;
  font-weight: 700;
  background: #D4A574;
  color: #2D2D2D;
  border-radius: 50%;
  margin-left: 8px;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}
.menu-cart.menu-cart-full span {
  box-shadow: 0 0 0 2px #C75D3D;
  animation: cartBounce 0.5s ease;
}
@keyframes cartBounce {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.3); }
}

@media (max-width: 1100px) {
  .site-search { display: none; }
}
.menu-cart {
  color: #FFFFFF;
  padding: 10px 18px;
  background: #C75D3D;
  border-radius: 24px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.2px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.25s ease;
}
.menu-cart:hover {
  background: #A1482A;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(185, 54, 91, 0.35);
  color: #FFFFFF;
}
.menu-cart-full {
  background: #D4A574;
  color: #2D2D2D;
}
.el-menu--horizontal > .el-menu-item {
  color: #2D2D2D;
  font-weight: 500;
  letter-spacing: 0.3px;
}
.el-menu--horizontal > .el-menu-item.is-active {
  color: #C75D3D;
}
.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover {
  color: #C75D3D;
}
.el-menu--horizontal > .el-submenu .el-submenu__title {
  color: #2D2D2D;
  font-weight: 500;
  letter-spacing: 0.3px;
}
.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  color: #C75D3D;
}
.el-menu--horizontal > .el-submenu:not(.is-disabled):hover .el-submenu__title {
  color: #C75D3D;
}

/* 顶栏容器CSS END */

/* 底栏容器CSS */
.footer {
  width: 100%;
  background: #F5F7FA;
  color: #2D2D2D;
  padding: 60px 0 0;
}
.footer-subscribe-section {
  background: linear-gradient(135deg, #C75D3D 0%, #A1482A 100%);
  padding: 50px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1280px;
  margin: 0 auto;
  border-radius: 24px 24px 0 0;
  position: relative;
  overflow: hidden;
}
.footer-subscribe-section::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 300px;
  height: 100%;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.08'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}
.subscribe-title {
  font-size: 32px;
  font-weight: 700;
  color: #FFFFFF;
  font-family: 'Georgia', serif;
  letter-spacing: 0.5px;
  position: relative;
  z-index: 1;
}
.subscribe-action {
  display: flex;
  align-items: center;
  position: relative;
  z-index: 1;
}
.subscribe-btn-arrow {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  border: 2px solid #FFFFFF;
  background: transparent;
  color: #FFFFFF;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}
.subscribe-btn-arrow:hover {
  background: #FFFFFF;
  color: #C75D3D;
  transform: scale(1.05);
}
.footer-content {
  max-width: 1280px;
  margin: 0 auto;
  padding: 60px 24px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 40px;
}
.footer-links-group {
  flex: 2;
  display: flex;
  justify-content: space-around;
  gap: 60px;
}
.footer-col h4 {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 20px;
  color: #C75D3D;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.footer-col a {
  display: block;
  color: #6B6B6B;
  font-size: 14px;
  margin-bottom: 12px;
  transition: all 0.3s ease;
  position: relative;
  padding-left: 0;
}
.footer-col a::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 2px;
  background: #C75D3D;
  transition: width 0.3s ease;
}
.footer-col a:hover {
  color: #C75D3D;
  padding-left: 16px;
}
.footer-col a:hover::before {
  width: 8px;
}
.footer-col a:hover {
  color: #C75D3D;
}
.footer-right-promo {
  text-align: right;
  max-width: 280px;
}
.footer-right-promo h4 {
  font-size: 16px;
  font-weight: 700;
  color: #C75D3D;
  margin-bottom: 10px;
}
.footer-right-promo p {
  font-size: 13px;
  color: #6B6B6B;
  margin-bottom: 16px;
  line-height: 1.6;
}
.footer-promo-links a {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 13px;
  color: #2D2D2D;
  margin-bottom: 10px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s ease;
}
.footer-promo-links a:hover {
  color: #C75D3D;
  transform: translateX(-4px);
}
.footer-promo-links a i {
  margin-left: 8px;
}
.footer-copyright {
    text-align: center;
    padding: 24px 0;
    font-size: 13px;
    color: #9B9B9B;
    border-top: 1px solid rgba(185, 54, 91, 0.1);
    max-width: 1280px;
    margin: 0 auto;
  }
/* 底栏容器CSS END */

/* 移动端适配 */
@media (max-width: 900px) {
  .el-header {
    display: none;
  }
  #app .el-main {
    padding-top: 56px;
    padding-bottom: 64px;
  }
  .mobile-header {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100vw;
    height: 56px;
    background: linear-gradient(135deg, #C75D3D 0%, #A1482A 100%);
    z-index: 1000;
    border-bottom: 0;
  }
  .mobile-header-inner {
    width: 100%;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
    color: #ffffff;
  }
  .mobile-header a {
    color: #ffffff;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .mobile-logo img {
    height: 34px;
    border-radius: 8px;
  }
  .mobile-cart {
    position: relative;
    margin-right: 28px;
  }
  .mobile-cart .badge {
    position: absolute;
    top: -6px;
    right: -10px;
    background: #D4A574;
    color: #2D2D2D;
    font-size: 10px;
    font-weight: 700;
    padding: 3px 6px;
    border-radius: 10px;
  }
  .mobile-tabbar {
    position: fixed;
    left: 0;
    right: 0;
    width: 100vw;
    bottom: 0;
    height: 64px;
    background: #FFFFFF;
    border-top: 1px solid rgba(185, 54, 91, 0.1);
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    z-index: 20;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.06);
  }
  .mobile-tabbar .tab {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #9B9B9B;
    position: relative;
    font-size: 11px;
    gap: 4px;
    transition: all 0.3s ease;
  }
  .mobile-tabbar .tab::after {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%) scaleY(0);
    width: 40px;
    height: 3px;
    background: linear-gradient(90deg, #C75D3D, #D4A574);
    border-radius: 0 0 3px 3px;
    transition: transform 0.3s ease;
  }
  .mobile-tabbar .tab i {
    font-size: 20px;
    transition: transform 0.3s ease;
  }
  .mobile-tabbar .tab.router-link-active {
    color: #C75D3D;
  }
  .mobile-tabbar .tab.router-link-active::after {
    transform: translateX(-50%) scaleY(1);
  }
  .mobile-tabbar .tab.router-link-active i {
    transform: translateY(-2px);
  }
  .mobile-tabbar .tab .dot {
    position: absolute;
    right: calc(50% - 16px);
    top: 8px;
    font-size: 10px;
    color: #FFFFFF;
    background: #C75D3D;
    border-radius: 10px;
    padding: 2px 5px;
    line-height: 1;
    animation: cartBounce 0.5s ease;
  }
  .footer {
    border-radius: 16px 16px 0 0;
    width: 100vw;
    padding-bottom: calc(16px + 64px);
  }
  .footer-content {
    flex-direction: column;
    gap: 30px;
  }
  .footer-left, .footer-links-group, .footer-right {
    max-width: 100%;
    flex: auto;
  }
  .footer-links-group {
    justify-content: space-between;
  }
}

/* 抽屉菜单样式（小屏专用） */
@media (max-width: 900px) {
  .mobile-drawer {
    background: #FDF8F5 !important;
  }
  .mobile-drawer .el-drawer__body {
    padding: 0;
    background: #FDF8F5;
    color: #2D2D2D;
  }
  .mobile-drawer-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid rgba(185, 54, 91, 0.1);
    font-weight: 600;
    color: #FFFFFF;
    background: linear-gradient(135deg, #C75D3D 0%, #A1482A 100%);
  }
  .mobile-drawer-header i {
    font-size: 20px;
    cursor: pointer;
    color: #FFFFFF;
  }
  .mobile-drawer-body {
    padding: 16px 20px 32px;
    background: #FDF8F5;
  }
  .mobile-search {
    margin-bottom: 16px;
  }
  .mobile-search >>> .el-input__inner {
    background: #FFFFFF;
    border: 1.5px solid rgba(185, 54, 91, 0.15);
    color: #2D2D2D;
  }
  .mobile-search >>> .el-input-group__append .el-button {
    background: #C75D3D;
    border: 1px solid #C75D3D;
    color: #FFFFFF;
  }
  .drawer-switch {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin-bottom: 10px;
  }
  .drawer-switch .switch-btn {
    height: 42px;
    border-radius: 8px;
    background: #FFFFFF;
    color: #2D2D2D;
    font-weight: 600;
    border: 1.5px solid rgba(185, 54, 91, 0.15);
    transition: all 0.2s ease;
  }
  .drawer-switch .switch-btn.active {
    background: #C75D3D;
    color: #ffffff;
    box-shadow: none;
    border-color: #C75D3D;
  }
  .drawer-content {
    height: calc(100vh - 160px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .mobile-drawer-section .section-title,
  .drawer-col .section-title {
    font-size: 12px;
    letter-spacing: 0.5px;
    color: #C75D3D;
    margin-bottom: 10px;
    text-transform: uppercase;
    font-weight: 700;
  }
  .mobile-drawer-section .link-list li a,
  .drawer-col .link-list li a {
    display: block;
    padding: 14px 0;
    border-bottom: 1px solid rgba(185, 54, 91, 0.1);
    color: #2D2D2D;
  }
  .mobile-drawer-section .link-list li a:hover {
    color: #C75D3D;
  }
  /* 两栏布局 */
  .drawer-columns {
    display: none;
  }
  .drawer-col {
    padding-right: 0;
  }
  .drawer-left {
    border-right: 0;
  }
}
</style>
